// FI-2265: the legacy VSM pages save a row's half-entered status record in
// beforeDestroy (flushActiveEdits), and a build refresh never gets there: a
// page reload skips beforeDestroy. report the rows flagged in
// active_edit_names (the ones flushActiveEdits would save) to the FI-2181
// build watcher as unsaved work, so the navigation reload, the board
// self-reload and the nudge's Refresh now all wait until they are saved.
//
// a row is flagged on focus, so a board left with a focused-but-unsaved row
// waits for a manual reload instead of updating itself.
import { registerDirtyCheck, unregisterDirtyCheck } from '@/utils/build_watcher'

export function hasActiveEdits(activeEditNames) {
  return Object.keys(activeEditNames || {}).length > 0
}

export default {
  mounted() {
    this._vsmBuildDirtyCheck = () => hasActiveEdits(this.active_edit_names)
    registerDirtyCheck(this._vsmBuildDirtyCheck)
  },

  beforeDestroy() {
    unregisterDirtyCheck(this._vsmBuildDirtyCheck)
  },
}
